import { createContext, useContext, useState } from 'react'

const IntakeContext = createContext()

export const IntakeProvider = ({ children }) => {
  const [sleepTime, setSleepTime] = useState(null)
  const [awakeTime, setAwakeTime] = useState(null)
  const [caffeineProducts, setCaffeineProducts] = useState([])
  const [selectedCaffeineOptions, setSelectedCaffeineOptions] = useState([])
  const [caffeineTime, setCaffeineTime] = useState(null)

  return (
    <IntakeContext.Provider
      value={{
        caffeineProducts,
        setCaffeineProducts,
        selectedCaffeineOptions,
        setSelectedCaffeineOptions,
        sleepTime,
        setSleepTime,
        awakeTime,
        setAwakeTime,
        caffeineTime,
        setCaffeineTime,
      }}
    >
      {children}
    </IntakeContext.Provider>
  )
}

export const useIntake = () => {
  return useContext(IntakeContext)
}
